const initCartManager = function () {
  console.log('Initializing CartManager');
  const bookingUrl = '/fortbildung/anmeldung/schritt1';
  let overlay;
  let dialog;
  let buttonText;

  function openAddToCartConfirmationLayer(label) {
    const body = document.body;
    overlay = document.createElement('div');
    overlay.classList.add('cart-layer__overlay');

    const dialogHtml = `
      <div class="cart-layer__dialog">
        <h2 class="cart-layer__headline">Zum Warenkorb hinzugefügt</h2>
        ${label}
        <div class="cart-layer__button-row">
          <button class="cart-layer__close-button">Weiter umsehen</button>
          <a class="cart-layer__link" href="${bookingUrl}">zur Buchung &rarr;</a>
        </div>
      </div>
    `;

    body.classList.add('modal-open');
    overlay.innerHTML = dialogHtml;
    body.appendChild(overlay);

    dialog = overlay.querySelector('.cart-layer__dialog');
    dialog.classList.add('open');
    document.querySelectorAll('.row, .blueprint-details').forEach(el => el.classList.add('u-blur'));

    overlay.querySelector('.cart-layer__close-button').addEventListener('click', closeAddToCartConfirmationLayer);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        closeAddToCartConfirmationLayer(e);
      }
    });
  }

  function closeAddToCartConfirmationLayer(e) {
    e.preventDefault();
    document.querySelectorAll('.row, .blueprint-details').forEach(el => el.classList.remove('u-blur'));
    document.body.classList.remove('modal-open');

    dialog.style.top = '-200px';
    dialog.style.opacity = '0';

    setTimeout(() => {
      dialog.remove();
    }, 250);

    overlay.style.opacity = '0';
    setTimeout(() => {
      overlay.remove();
    }, 500);
  }

  // Adding to cart opens layer
  document.addEventListener('ajax:send', function (event) {
    if (event.target.matches('form.addToCart')) {
      const form = event.target;

      form.addEventListener('ajax:complete', () => {
        let layerLabel = form.dataset.orderType === 'booking' ? 'Kursbuchung' : 'Wartelistenplatzreservierung';
        layerLabel = `<p>Ihre ${layerLabel} wurde im Warenkorb abgelegt.</p>Möchten Sie sich weiter umsehen oder nun zur Buchung?`;
        openAddToCartConfirmationLayer(layerLabel);
      });
    }
  });

  function closeCartSection() {
    const cartContent = document.querySelector('.cart-section__cart-content');
    const cartSection = document.querySelector('.cart-section');
    const buttonShow = document.querySelector('.cart-section__button.show');

    if (cartContent && cartSection && buttonShow) {
      cartContent.style.maxHeight = '0';
      cartSection.classList.remove('is-open');
      buttonShow.removeEventListener('click', closeCartSection);
      buttonShow.addEventListener('click', openCartSection);
      buttonShow.innerHTML = buttonText;
    }
  }

  function openCartSection() {
    const buttonShow = document.querySelector('.cart-section__button.show');
    const cartContent = document.querySelector('.cart-section__cart-content');
    const cartSection = document.querySelector('.cart-section');

    if (cartContent && cartSection && buttonShow) {
      buttonText = buttonShow.innerHTML;
      buttonShow.innerHTML = 'Warenkorb schließen';
      cartContent.style.maxHeight = `${cartContent.scrollHeight}px`;
      cartSection.classList.add('is-open');
      buttonShow.removeEventListener('click', openCartSection);
      buttonShow.addEventListener('click', closeCartSection);
    }
  }

  document.addEventListener('DOMContentLoaded', closeCartSection);
};

export default initCartManager;
